var CompactHeader         = require("./CompactHeader"),
    HeaderCover           = require("./HeaderCover"),
    HorizontalDescription = require("./HorizontalDescription"),
    MediaHeader           = require("app/ui/header/MediaHeader"),
    VerticalDescription   = require("./VerticalDescription"),
    HeaderVariables       = require("app/theme/styles/headers/HeaderVariables"),
    kind                  = require("enyo/kind");

module.exports = kind(/** @lends  app.MagazinePage.Header.prototype */ {

    /**
     * @private
     */
    name: "app.MagazinePage.Header",

    /**
     * @private
     */
    kind: MediaHeader,

    /**
     * @private
     */
    classes: "app-magazine-page-header",

    /**
     * The kind that will be rendered as compact header.
     *
     * @type {enyo.Control}
     * @public
     */
    compactHeaderKind: CompactHeader,

    /**
     * The kind that will be rendered as horizontal description.
     *
     * @type {enyo.Control}
     * @public
     */
    horizontalDescriptionKind: HorizontalDescription,

    /**
     * The kind that will be rendered as vertical description.
     *
     * @type {enyo.Control}
     * @public
     */
    verticalDescriptionKind: VerticalDescription,

    /**
     * The kind that will be rendered as cover.
     *
     * @type {enyo.Control}
     * @public
     */
    coverKind: HeaderCover,

    /**
     * @protected
     */
    update: kind.inherit(function(sup) {
        return function() {
            var data = this.data || {};

            this.set("coverFormFactor", HeaderVariables.getCoverFormFactor(data));
            sup.apply(this, arguments);
        };
    })

});
